import * as angular from 'angular';

"use strict";
angular.module('FilterModule', []);

export default 'FilterModule';
